import { tsValidateString, tsValidateValue, tsValidator_nonMandatoryString } from '@nu-art/ts-common';
import { DiscussionType_Chat, DiscussionType_GladosIssue } from './consts.js';
const Validator_ModifiableProps = {
    topicId: tsValidateString(),
    type: tsValidateValue([DiscussionType_Chat, DiscussionType_GladosIssue]),
    status: tsValidator_nonMandatoryString,
};
const Validator_GeneratedProps = {
    _auditorId: tsValidateString(),
};
export const DBDef_Discussion = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'discussions',
    entityName: 'discussion',
    frontend: {
        group: 'messaging',
        name: 'discussion'
    },
    backend: {
        name: 'discussions'
    },
    dependencies: {
        topicId: {
            dbKey: 'topics',
            fieldType: 'string'
        }
    }
};
//# sourceMappingURL=db-def.js.map